import React from "react";
import { roundMoneyValue } from "../../../../utils/functions";

function Dietitian(props) {
  const { dietitian, dietType } = props;

  const createDietsTitle = (dietType) => {
    switch (dietType) {
      case "Mediterranean Plan":
        return "Mediterranean FIT™ Quickstart Program";
      case "Low-FODMAP Plan":
        return "Low FODMAP FIT™ Quickstart Program";
      case "Diabetes Plan":
        return "Diabetes-Friendly FIT™ Quickstart Program";
      case "Gluten-Free Plan":
        return "Gluten-Free FIT™ Quickstart Program";
      case "Heart-Friendly Plan":
        return "Heart-Friendly FIT™ Quickstart Program";
      case "Carb-Conscious Plan":
        return "Carb-Conscious FIT™ Quickstart Program";
      case "B2B Plan":
          return "B2B FIT™ Quickstart Program";
      case "GLP-1 Plan":
          return "GLP-1 FIT™ Quickstart Program";
      default:
        return "404";
    }
  };

  const title = createDietsTitle(dietType)


  return (
    <>
      {dietitian.support && (
        <>
          <div className="product-nav__title">{title}</div>
          <dl className="price">
            <div className="price__regular">
              <dd>
                <span className="price-item price-item--regular">{dietitian.price > 0 && "$" + roundMoneyValue(dietitian.price)}</span>
              </dd>
            </div>
          </dl>{" "}
        </>
      )}
    </>
  );
}

export default Dietitian;
